import React from 'react';
import PropTypes from 'prop-types';
import { OptionsGroup } from '@/vacancy_request/components/template-request-form/options-group';
import { optionsList } from '@/vacancy_request/components/template-request-form/options-group/constants';
import { useTranslationWithPrefix } from '@/i18n/hooks';
import { Separate } from '@components/styles/hr-styles';
import { CustomFieldsSection } from '@/vacancy_request/components/template-request-form/custom-fields/custom-fields-section';
import { CUSTOM_FIELD_TABS } from '@/vacancy_request/components/template-request-form/custom-fields/constants';

const ApplicantInformationTab = (props) => {
  const { disabled } = props;

  const { t } = useTranslationWithPrefix('requestVacancies.requestTemplate.form.stepThree');

  return (
    <>
      {/* Experiencia */}
      <OptionsGroup name='experience' label={t('fields.experience.label')} options={optionsList} disabled={disabled} />
      <Separate margin='0' />

      {/* Jerarquía */}
      <OptionsGroup name='c_hierarchy' label={t('fields.cHierarchy.label')} options={optionsList} disabled={disabled} />
      <Separate margin='0' />

      {/* Idiomas */}
      <OptionsGroup
        name='selectedLanguages'
        label={t('fields.languages.label')}
        options={optionsList}
        disabled={disabled}
      />
      <Separate margin='0' />

      {/* Gente a cargo */}
      <OptionsGroup
        name='hasPeopleInCharge'
        label={t('fields.hasPeopleInCharge.label')}
        options={optionsList}
        disabled={disabled}
      />
      <Separate margin='0' />

      {/* Disponibilidad para viajar */}
      <OptionsGroup
        name='travel_availability'
        label={t('fields.travelAvailability.label')}
        options={optionsList}
        disabled={disabled}
      />
      <Separate margin='0' />

      {/* Requisitos del puesto */}
      <OptionsGroup
        name='requirements'
        label={t('fields.requirements.label')}
        options={optionsList}
        disabled={disabled}
      />
      <Separate margin='0' />

      {/* Beneficios */}
      <OptionsGroup name='benefits' label={t('fields.benefits.label')} options={optionsList} disabled={disabled} />
      <Separate margin='0' />

      {/* Archivos adjuntos */}
      <OptionsGroup
        name='attachedFile'
        label={t('fields.attachedFile.label')}
        options={optionsList}
        disabled={disabled}
      />
      <Separate margin='0' />

      {/* Campos personalizados */}
      <CustomFieldsSection tab={CUSTOM_FIELD_TABS.CANDIDATE_DETAILS} disabled={disabled} />
    </>
  );
};

ApplicantInformationTab.propTypes = {
  disabled: PropTypes.bool
};

ApplicantInformationTab.defaultProps = {
  disabled: false
};

export default ApplicantInformationTab;
